import styled from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { COLORS } from '~/src/styles/tokens/colors';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

export const ErrorNotificationContainer = styled.div`
    width: fit-content;
    height: fit-content;
    min-height: ${rem(36)};
    padding: ${rem(8)} ${rem(12)};
    background-color: ${COLORS.backgroundInverted};
    border-radius: ${BORDER_RADIUS.bigger12};
    z-index: ${Z_INDEX.top};
`;

export const ErrorNotificationWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: ${rem(9)};
`;

export const IconWrapper = styled.div`
    display: flex;
`;

export const Text = styled.span`
    white-space: pre;
    ${FONTS.compact.regular.size14};
    color: ${COLORS.textInverted};
`;